import { Container, AppHeader, Typography, Button, ButtonGroup } from '@ace-clublabs/shared-component-library';
import maintenancePageImg from '../assets/maintenance_page.png';
import { ExternalCTAs } from '../utils/constants';

interface IMaintenancePageProps {}

export const MaintenancePage: React.FC<IMaintenancePageProps> = (props: IMaintenancePageProps) => {
  const onClick = () => {
    window.location.href = ExternalCTAs.homepage;
  };

  return (
    <Container maxWidth="sm">
      <AppHeader />

      <img
        src={maintenancePageImg}
        className="maintenance-page-img"
        alt="maintenance-page-img"
        style={{ width: '100%', marginBottom: '0.5rem' }}
      />

      <Typography
        className="maintenance-page-title"
        variant="h5"
        sx={{ fontWeight: '500', color: '#404040', marginBottom: '1rem' }}
      >
        We’re working on improvements
      </Typography>
      <Typography
        className="maintenance-page-description"
        variant="body1"
        sx={{ fontWeight: '400', color: '#404040', marginBottom: '1rem' }}
      >
        Our system is currently undergoing maintenance to improve your experience. Please check back later and we
        apologize for any inconvenience.
      </Typography>

      <ButtonGroup>
        <Button className="maintenance-page-button" onClick={onClick} label="Return to homepage" fullWidth />
      </ButtonGroup>
    </Container>
  );
};
